var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCapEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "234 62 238.538 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #41463e;\n      }\n\n      .cls-2 {\n        fill: #81c241;\n      }\n\n      .cls-3 {\n        fill: #c9da2f;\n      }\n\n      .cls-4 {\n        fill: #2d953e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(234 62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(83.664 99.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M53.358,73.436H52.4V62.1h.958Z",
    transform: "translate(-52.4 -62.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M60.329,66.534V72.6h-.958V66.534c0-1.437-.479-2.076-1.277-2.076-.958,0-1.6.8-2.235,1.756v6.227H54.9V63.819h.8l.16,1.437C56.5,64.3,57.135,63.5,58.253,63.5,59.69,63.819,60.329,64.777,60.329,66.534Z",
    transform: "translate(-50.908 -61.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "M65.629,66.534V72.6h-.958V66.534c0-1.437-.479-2.076-1.277-2.076-.958,0-1.6.8-2.235,1.756v6.227H60.2V63.819H61l.16,1.437C61.8,64.3,62.435,63.5,63.553,63.5,64.83,63.819,65.629,64.777,65.629,66.534Z",
    transform: "translate(-47.746 -61.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M71.387,68.171c0,2.874-1.277,4.471-3.193,4.471S65,71.045,65,68.171,66.277,63.7,68.193,63.7,71.387,65.137,71.387,68.171Zm-5.269,0c0,2.555.8,3.672,2.235,3.672s2.235-1.118,2.235-3.672-.8-3.672-2.235-3.672S66.118,65.616,66.118,68.171Z",
    transform: "translate(-44.882 -61.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M73.532,72.422H72.414L69.7,63.8h.958l2.235,7.824L74.969,63.8h.958Z",
    transform: "translate(-42.078 -61.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M80.467,72l-.16.639A1.541,1.541,0,0,1,79.03,71.2a2.422,2.422,0,0,1-4.63-1.118c0-1.756,1.118-2.714,3.193-2.714h1.277v-.958c0-1.277-.479-1.916-1.6-1.916a5.512,5.512,0,0,0-2.076.479l-.16-.639a6.691,6.691,0,0,1,2.395-.639c1.756,0,2.395.958,2.395,2.555v4.471C79.829,71.524,79.988,71.843,80.467,72Zm-1.6-1.6V68.011H77.753c-1.6,0-2.395.639-2.395,2.076,0,1.277.639,1.916,1.6,1.916A2.024,2.024,0,0,0,78.871,70.406Z",
    transform: "translate(-39.274 -61.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M83.69,73a2.7,2.7,0,0,1-1.6.479A1.89,1.89,0,0,1,80.177,71.4V65.334H78.9v-.8h1.277V62.46l.958-.16v2.235h1.916l-.16.8H81.135V71.4c0,.8.319,1.277,1.118,1.277a2.308,2.308,0,0,0,1.118-.319Z",
    transform: "translate(-36.589 -61.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M88.248,68.55H83.3c.16,2.395.958,3.353,2.235,3.353a3.363,3.363,0,0,0,2.076-.8l.479.479A3.4,3.4,0,0,1,85.693,72.7c-1.916,0-3.193-1.6-3.193-4.471s1.118-4.63,3.034-4.63,2.874,1.437,2.874,4.151A3.248,3.248,0,0,1,88.248,68.55Zm-.8-.958c0-2.076-.639-3.193-1.916-3.193-1.118,0-2.076.958-2.076,3.353h4.151v-.16Z",
    transform: "translate(-34.441 -61.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M88.7,69.1a.855.855,0,0,1-.8.8.754.754,0,0,1-.8-.8.8.8,0,0,1,1.6,0Z",
    transform: "translate(-31.697 -58.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M98.566,63.07l-.479.639a2.78,2.78,0,0,0-2.235-.8c-1.6,0-3.034,1.277-3.034,4.95,0,3.513,1.118,5.109,3.034,5.109a2.545,2.545,0,0,0,1.916-.639V68.338H95.851l-.16-.8h2.874v5.269a4.458,4.458,0,0,1-2.874.958c-2.395,0-3.992-1.916-3.992-5.908,0-3.832,1.916-5.748,4.151-5.748A3.375,3.375,0,0,1,98.566,63.07Z",
    transform: "translate(-28.952 -62.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "M101.372,63.86l-.16.8c-.16,0-.319-.16-.639-.16-.958,0-1.6.8-1.916,2.555v5.429H97.7V63.86h.8l.16,1.756c.479-1.277,1.118-1.916,2.076-1.916A.96.96,0,0,1,101.372,63.86Z",
    transform: "translate(-25.372 -61.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M107.087,68.171c0,2.874-1.277,4.471-3.193,4.471s-3.193-1.6-3.193-4.471,1.277-4.471,3.193-4.471S107.087,65.137,107.087,68.171Zm-5.429,0c0,2.555.8,3.672,2.235,3.672s2.235-1.118,2.235-3.672-.8-3.672-2.235-3.672S101.658,65.616,101.658,68.171Z",
    transform: "translate(-23.582 -61.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-1",
    d: "M113,72.422h-1.277l-1.6-7.664-1.6,7.664h-1.277L105.5,63.8h.958l1.6,7.824,1.6-7.824h1.118l1.6,7.824,1.6-7.824h.958Z",
    transform: "translate(-20.718 -61.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-1",
    d: "M113.7,69.1a.855.855,0,0,1-.8.8.754.754,0,0,1-.8-.8.855.855,0,0,1,.8-.8C113.377,68.46,113.7,68.779,113.7,69.1Z",
    transform: "translate(-16.781 -58.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-1",
    d: "M123.008,65.559c0,2.395-1.437,3.513-3.992,3.513h-.958v4.471H117.1V62.206h1.916C121.73,62.046,123.008,63.164,123.008,65.559Zm-.958,0c0-1.916-.958-2.555-3.034-2.555h-.958v5.269h.958C120.932,68.113,122.05,67.475,122.05,65.559Z",
    transform: "translate(-13.797 -62.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-1",
    d: "M125.872,63.86l-.16.8c-.16,0-.319-.16-.639-.16-.958,0-1.6.8-1.916,2.555v5.429H122.2V63.86h.8l.16,1.756c.479-1.277,1.118-1.916,2.076-1.916A1.207,1.207,0,0,1,125.872,63.86Z",
    transform: "translate(-10.755 -61.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-1",
    d: "M131.587,68.171c0,2.874-1.277,4.471-3.193,4.471s-3.193-1.6-3.193-4.471,1.277-4.471,3.193-4.471S131.587,65.137,131.587,68.171Zm-5.429,0c0,2.555.8,3.672,2.235,3.672s2.235-1.118,2.235-3.672-.8-3.672-2.235-3.672S126.158,65.616,126.158,68.171Z",
    transform: "translate(-8.965 -61.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-1",
    d: "M135.269,64.614l-.479.639a2.946,2.946,0,0,0-1.916-.8,1.474,1.474,0,0,0-1.6,1.437c0,.8.479,1.277,1.756,1.756,1.6.639,2.395,1.118,2.395,2.555a2.559,2.559,0,0,1-2.714,2.555A3.577,3.577,0,0,1,130,71.639l.479-.479a2.9,2.9,0,0,0,2.235.958,1.675,1.675,0,0,0,1.756-1.756c0-.958-.479-1.437-1.916-1.916-1.6-.479-2.235-1.277-2.235-2.395a2.367,2.367,0,0,1,2.555-2.235A2.5,2.5,0,0,1,135.269,64.614Z",
    transform: "translate(-6.101 -61.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M140.708,68.115c0,2.874-.958,4.471-2.874,4.471a2.492,2.492,0,0,1-2.076-1.118v4.311l-.958.16V63.964h.8v1.277a2.7,2.7,0,0,1,2.235-1.437C139.909,63.644,140.708,65.241,140.708,68.115Zm-.958,0c0-2.555-.639-3.672-1.916-3.672a2.46,2.46,0,0,0-2.076,1.437v4.63a2.252,2.252,0,0,0,1.916,1.277C139.111,71.787,139.75,70.67,139.75,68.115Z",
    transform: "translate(-3.237 -61.059)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M145.548,68.55H140.6c.16,2.395.958,3.353,2.235,3.353a3.363,3.363,0,0,0,2.076-.8l.479.479a3.4,3.4,0,0,1-2.395,1.118c-1.916,0-3.193-1.6-3.193-4.471s1.118-4.63,3.034-4.63,2.874,1.437,2.874,4.151A2.137,2.137,0,0,0,145.548,68.55Zm-.8-.958c0-2.076-.639-3.193-1.916-3.193-1.118,0-2.076.958-2.076,3.353h4.151v-.16Z",
    transform: "translate(-0.254 -61.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M148.572,63.86l-.16.8c-.16,0-.319-.16-.639-.16-.958,0-1.6.8-1.916,2.555v5.429H144.9V63.86h.8l.16,1.756c.479-1.277,1.118-1.916,2.076-1.916A.96.96,0,0,1,148.572,63.86Z",
    transform: "translate(2.789 -61.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-1",
    d: "M149.4,69.1a.855.855,0,0,1-.8.8.754.754,0,0,1-.8-.8.855.855,0,0,1,.8-.8C149.077,68.46,149.4,68.779,149.4,69.1Z",
    transform: "translate(4.519 -58.37)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-2",
    d: "M58.537,58.4a2.03,2.03,0,0,0,1.916-2.235V52.335A2.03,2.03,0,0,0,58.537,50.1H2.016A2.03,2.03,0,0,0,.1,52.335v3.832A2.03,2.03,0,0,0,2.016,58.4Z",
    transform: "translate(0.06 29.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-2",
    d: "M58.537,49.6a2.03,2.03,0,0,0,1.916-2.235V43.535A2.03,2.03,0,0,0,58.537,41.3H2.016A2.03,2.03,0,0,0,.1,43.535v3.832A2.03,2.03,0,0,0,2.016,49.6Z",
    transform: "translate(0.06 24.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-3",
    d: "M96.7,11.135A2.183,2.183,0,0,0,94.461,8.9H2.335A2.183,2.183,0,0,0,.1,11.135v3.832A2.183,2.183,0,0,0,2.335,17.2H94.461A2.183,2.183,0,0,0,96.7,14.967Z",
    transform: "translate(0.06 5.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-3",
    d: "M96.7,2.335A2.183,2.183,0,0,0,94.461.1H2.335A2.183,2.183,0,0,0,.1,2.335V6.167A2.183,2.183,0,0,0,2.335,8.4H94.461A2.183,2.183,0,0,0,96.7,6.167Z",
    transform: "translate(0.06 0.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-4",
    d: "M41.353,31.735A2.183,2.183,0,0,0,39.118,29.5H2.235A2.183,2.183,0,0,0,0,31.735v3.832A2.183,2.183,0,0,0,2.235,37.8H39.118a2.183,2.183,0,0,0,2.235-2.235Z",
    transform: "translate(0 17.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-4",
    d: "M41.353,23.035A2.183,2.183,0,0,0,39.118,20.8H2.235A2.183,2.183,0,0,0,0,23.035v3.832A2.183,2.183,0,0,0,2.235,29.1H39.118a2.183,2.183,0,0,0,2.235-2.235Z",
    transform: "translate(0 12.41)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(111.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M84.05,2.235,82.134,4.63a5.454,5.454,0,0,0-3.513-1.6c-2.555,0-4.471,2.076-4.471,8.3,0,6.067,1.756,8.3,4.471,8.3a5.056,5.056,0,0,0,3.672-1.756l1.916,2.235a7.62,7.62,0,0,1-5.748,2.714c-5.109,0-8.462-3.672-8.462-11.5C70,3.672,73.513,0,78.462,0A7.706,7.706,0,0,1,84.05,2.235Z",
    transform: "translate(-70 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M90.276,17.224H84.209l-1.118,5.109H79.1L85.008.3h4.95l5.748,22.034H91.554Zm-.639-3.193-2.395-10.7-2.395,10.7Z",
    transform: "translate(-64.571 0.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M105.129,22.334H100.02L93.793,4.292c.16,1.916.479,4.79.479,8.782v9.261H90.6V.3h5.109l6.067,18.042a67.443,67.443,0,0,1-.479-7.5V.3h3.672V22.334Z",
    transform: "translate(-57.709 0.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M112.176,17.224h-6.067l-1.118,5.109H101L106.908.3h4.95l5.748,22.034h-4.151Zm-.639-3.193-2.395-10.7-2.395,10.7Z",
    transform: "translate(-51.504 0.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M127.289,11.157c0,8.941-4.63,11.176-9.261,11.176H112.6V.3h4.95C122.659.3,127.289,1.9,127.289,11.157Zm-10.7-7.824V19.3h1.6c2.714,0,4.79-1.437,4.79-8.143,0-6.866-2.235-7.824-4.95-7.824h-1.437Z",
    transform: "translate(-44.583 0.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-1",
    d: "M127.951,22.334H123.8V.3h4.151Z",
    transform: "translate(-37.901 0.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-1",
    d: "M138.977,17.224h-6.067l-1.118,5.109H127.8L133.708.3h4.95l5.748,22.034h-4.151Zm-.8-3.193-2.395-10.7-2.395,10.7Z",
    transform: "translate(-35.514 0.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-1",
    d: "M153.67,22.334H148.56L142.493,4.292c.16,1.916.479,4.79.479,8.782v9.261H139.3V.3h5.109l6.067,18.042a67.443,67.443,0,0,1-.479-7.5V.3h3.672Z",
    transform: "translate(-28.653 0.179)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(55.563 32.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-1",
    d: "M45.976,37.824H39.909l-1.118,5.109H34.8L40.708,20.9h4.95l5.748,22.034H47.254Zm-.639-3.034-2.395-10.7-2.395,10.7Z",
    transform: "translate(-34.8 -20.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M60.508,23.1l-2.076,2.076a5.543,5.543,0,0,0-3.992-1.6c-2.714,0-4.79,2.235-4.79,8.462S51.088,40.5,53.962,40.5a6.506,6.506,0,0,0,2.874-.8V33.8H54.122l-.479-3.034h7.025V41.622A12.316,12.316,0,0,1,53.962,43.7c-5.588,0-8.462-3.832-8.462-11.5,0-7.5,3.992-11.5,8.941-11.5A7.721,7.721,0,0,1,60.508,23.1Z",
    transform: "translate(-28.416 -20.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M63.327,33.992H61.251v8.941H57.1V20.9h5.588c5.588,0,8.143,2.235,8.143,6.546,0,2.874-1.118,4.63-3.832,5.908l4.95,9.739H67.478Zm-.479-2.874c2.555,0,3.672-1.118,3.672-3.672,0-2.395-1.118-3.513-3.992-3.513H61.092v7.185Z",
    transform: "translate(-21.495 -20.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M71.851,42.934H67.7V20.9h4.151Z",
    transform: "translate(-15.171 -20.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-1",
    d: "M86.61,22.895,84.534,25.29a5.454,5.454,0,0,0-3.513-1.6c-2.555,0-4.471,2.076-4.471,8.3,0,6.067,1.756,8.3,4.471,8.3a5.056,5.056,0,0,0,3.672-1.756l1.916,2.235a7.62,7.62,0,0,1-5.748,2.714c-5.109,0-8.462-3.672-8.462-11.5,0-7.664,3.672-11.5,8.462-11.5A8.969,8.969,0,0,1,86.61,22.895Z",
    transform: "translate(-12.366 -20.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-1",
    d: "M97.07,36.387c0,3.992-2.395,7.025-7.185,7.025S82.7,40.539,82.7,36.387V20.9h4.151V36.228c0,2.714.958,3.992,3.193,3.992s3.193-1.277,3.193-3.992V20.9h4.151V36.387Z",
    transform: "translate(-6.221 -20.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-1",
    d: "M98.251,39.581h7.5l-.479,3.353H94.1V20.9h4.151V39.581Z",
    transform: "translate(0.581 -20.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-1",
    d: "M113.431,24.093h-4.79v18.84H104.65V24.093H99.7V20.9h14.21Z",
    transform: "translate(3.922 -20.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-1",
    d: "M124.17,36.387c0,3.992-2.395,7.025-7.185,7.025s-7.185-2.874-7.185-7.025V20.9h4.151V36.228c0,2.714.958,3.992,3.193,3.992s3.193-1.277,3.193-3.992V20.9h4.151V36.387Z",
    transform: "translate(9.948 -20.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-1",
    d: "M127.427,33.992h-2.076v8.941H121.2V20.9h5.588c5.588,0,8.143,2.235,8.143,6.546,0,2.874-1.118,4.63-3.832,5.908l4.95,9.739h-4.471Zm-.479-2.874c2.555,0,3.672-1.118,3.672-3.672,0-2.395-1.118-3.513-3.992-3.513h-1.437v7.185Z",
    transform: "translate(16.75 -20.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-1",
    d: "M141.776,37.824h-6.067l-1.118,5.109H130.6L136.508,20.9h4.95l5.748,22.034h-4.151Zm-.639-3.034-2.395-10.7-2.395,10.7Z",
    transform: "translate(22.358 -20.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-1",
    d: "M146.251,39.581h7.5l-.479,3.353H142.1V20.9h4.151Z",
    transform: "translate(29.219 -20.261)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(75.202 66.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-1",
    d: "M58.6,48.146c0,4.79-2.874,6.706-7.664,6.706H49.016v8.622H47.1V41.6h3.832C56.041,41.6,58.6,43.835,58.6,48.146Zm-1.916,0c0-3.672-1.916-5.109-5.748-5.109H48.856V53.415h1.916C54.6,53.415,56.68,52.138,56.68,48.146Z",
    transform: "translate(-47.1 -41.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-1",
    d: "M66.576,57.507H58.753l-1.6,6.067H55.4L61.627,41.7h2.235l6.227,21.874H68.173Zm-.479-1.6L62.585,43.137,59.072,55.91Z",
    transform: "translate(-42.148 -41.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-1",
    d: "M77.018,63.474l-4.79-9.9H68.716v9.9H66.8V41.6h4.151c5.109,0,7.185,2.235,7.185,5.908,0,3.034-1.437,4.95-4.151,5.748l5.109,10.218Zm-.8-15.966c0-2.874-1.437-4.471-5.269-4.471H68.716v9.1h2.555C74.464,52.138,76.22,50.7,76.22,47.508Z",
    transform: "translate(-35.346 -41.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-1",
    d: "M88.073,43.2H82.645V63.474H80.729V43.2H75.3V41.6H88.233Z",
    transform: "translate(-30.275 -41.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-1",
    d: "M97.954,63.474H95.559l-8.622-19.8a63.1,63.1,0,0,1,.319,7.185V63.314H85.5V41.6h2.395l8.622,19.8c0-.958-.319-3.672-.319-6.387V41.6h1.756Z",
    transform: "translate(-24.189 -41.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-1",
    d: "M106.58,43.2H98.916v8.3h6.546v1.6H98.916v9.1H106.9v1.6H97V41.6h9.739Z",
    transform: "translate(-17.328 -41.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-1",
    d: "M116.118,63.474l-4.79-9.9h-3.513v9.9H105.9V41.6h4.151c5.109,0,7.185,2.235,7.185,5.908,0,3.034-1.437,4.95-4.151,5.748l5.109,10.218Zm-.8-15.966c0-2.874-1.437-4.471-5.269-4.471h-2.395v9.1h2.555C113.564,52.138,115.32,50.7,115.32,47.508Z",
    transform: "translate(-12.018 -41.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-1",
    d: "M126.615,43.795l-.958,1.118A5.956,5.956,0,0,0,121.346,43a3.653,3.653,0,0,0-3.832,3.672c0,2.235.958,3.353,4.311,4.471,3.513,1.277,5.429,2.874,5.429,6.387a6.208,6.208,0,0,1-6.387,6.387A8.041,8.041,0,0,1,114.8,61.2l1.118-1.118a7.157,7.157,0,0,0,4.95,2.235,4.317,4.317,0,0,0,4.471-4.63c0-2.555-1.118-3.672-4.471-4.95-3.832-1.437-5.429-3.034-5.429-5.908a5.464,5.464,0,0,1,5.748-5.429A7.208,7.208,0,0,1,126.615,43.795Z",
    transform: "translate(-6.708 -41.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-1",
    d: "M135.9,52.776h-8.781v10.7H125.2V41.6h1.916v9.58H135.9V41.6h1.916V63.474H135.9Z",
    transform: "translate(-0.503 -41.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-1",
    d: "M138.716,63.474H136.8V41.6h1.916Z",
    transform: "translate(6.418 -41.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-1",
    d: "M153.2,48.146c0,4.79-2.874,6.706-7.664,6.706h-1.916v8.622H141.7V41.6h3.832C150.641,41.6,153.2,43.835,153.2,48.146Zm-1.916,0c0-3.672-1.916-5.109-5.748-5.109h-2.076V53.415h1.916C149.2,53.415,151.28,52.138,151.28,48.146Z",
    transform: "translate(9.342 -41.281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCapEn);
export default __webpack_public_path__ + "static/media/logo-cap-en.08a8252860b7a8de26e86df3f6b87375.svg";
export { ForwardRef as ReactComponent };